export enum ContentItemStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

/** Mirrors ContentItemResponse from the UAM CMS backend (/api/content-items). */
export interface ContentItem {
  id: string;
  title: string;
  bodyText: string;
  status: ContentItemStatus;
  imageUrls: string[];
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface ContentItemPayload {
  title: string;
  bodyText: string;
}

export interface ContentItemImage {
  id: string;
  imageUrl: string;
  createdAt: string;
}
